export default "/list/static/images/Travelocity.svg";